import Loading from '@/components/loading'
import { Stepper } from '@/components/stepper'

import { FirstStep } from './first-step'
import { SecondStep } from './second-step'
import { useStyles } from './styles'
import { ThirdStep } from './third-step'

const steps = ['Informações Básicas', 'Carregar arquivos', 'Confirmar cadastro']
const stepComponents = [FirstStep, SecondStep, ThirdStep]

interface MainContentProps {
  activeStep: number
  isLoading?: boolean
}

export function MainContent({ activeStep, isLoading }: MainContentProps) {
  const classes = useStyles()

  const CurrentStepComponent = stepComponents[activeStep - 1]

  if (isLoading) return <Loading />

  return (
    <main className={classes.container}>
      <Stepper activeStep={activeStep - 1} steps={steps} />

      <CurrentStepComponent />
    </main>
  )
}
